import Vue from 'vue';
import i18n from '@/i18n';

Vue.filter('currency', value => {
  const val = formatNumber(value);
  return value >= 0 ? `${val}€` : `-${val}€`;
});

Vue.filter('neutralCurrency', value => {
  return formatNumber(value) + '€';
});

Vue.filter('currencyShort', value => {
  return nFormatter(value, 0);
});

Vue.filter('format', value => {
  return formatNumber(value);
});

function formatNumber(n) {
  return Math.abs(n).toLocaleString(i18n.locale);
}

function nFormatter(num, digits) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  const n = parseFloat((num / si[i].value).toFixed(digits));
  return n.toLocaleString(i18n.locale).replace(rx, '$1') + si[i].symbol;
}
